import {Component, ElementRef, ViewChild} from '@angular/core';
import {animate, AnimationEvent, style, transition, trigger} from '@angular/animations';
import {MegaMenuItem, MessageService} from 'primeng/api';
import {AppComponent} from './app.component';
import {AppMainComponent} from './app.main.component';
import {AuthenticationService} from './@shared/services/authentication.service';
import {CacheService} from './@shared/services/cache.service';
import {CommonService} from './@shared/services/common.service';
import {UserMgmtService} from './@shared/new-services/user-mgmt.service';
import {LoginDetailsService} from './login/login-details.service';


@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    // styles: ['.p-sidebar.p-sidebar.p-sidebar-content {background: #1A237E}'],
    styleUrls: ['./app.topbar.component.scss'],
    animations: [
        trigger('topbarActionPanelAnimation', [
            transition(':enter', [
                style({opacity: 0, transform: 'scaleY(0.8)'}),
                animate('.12s cubic-bezier(0, 0, 0.2, 1)', style({opacity: 1, transform: '*'})),
            ]),
            transition(':leave', [
                animate('.1s linear', style({opacity: 0}))
            ])
        ])
    ]
})
export class AppTopBarComponent {
    selectedRoles: any = [];
    loggedInUser;
    activeItem: number;
    switchUserRole = false;
    selectedCompanies: any = this.cacheService.retrieveParsedResponse('selected-companies-array');
    model: MegaMenuItem[] = [
        {
            label: 'UI KIT',
            items: [
                [
                    {
                        label: 'UI KIT 1',
                        items: [
                            {label: 'Form Layout', icon: 'pi pi-fw pi-id-card', routerLink: ['/uikit/formlayout']},
                            {label: 'Input', icon: 'pi pi-fw pi-check-square', routerLink: ['/uikit/input']},
                            {label: 'Float Label', icon: 'pi pi-fw pi-bookmark', routerLink: ['/uikit/floatlabel']},
                            {label: 'Button', icon: 'pi pi-fw pi-mobile', routerLink: ['/uikit/button']},
                            {label: 'File', icon: 'pi pi-fw pi-file', routerLink: ['/uikit/file']}
                        ]
                    }
                ],
                [
                    {
                        label: 'UI KIT 2',
                        items: [
                            {label: 'Table', icon: 'pi pi-fw pi-table', routerLink: ['/uikit/table']},
                            {label: 'List', icon: 'pi pi-fw pi-list', routerLink: ['/uikit/list']},
                            {label: 'Tree', icon: 'pi pi-fw pi-share-alt', routerLink: ['/uikit/tree']},
                            {label: 'Panel', icon: 'pi pi-fw pi-tablet', routerLink: ['/uikit/panel']},
                            {label: 'Chart', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/uikit/charts']}
                        ]
                    }
                ],
                [
                    {
                        label: 'UI KIT 3',
                        items: [
                            {label: 'Overlay', icon: 'pi pi-fw pi-clone', routerLink: ['/uikit/overlay']},
                            {label: 'Media', icon: 'pi pi-fw pi-image', routerLink: ['/uikit/media']},
                            {label: 'Menu', icon: 'pi pi-fw pi-bars', routerLink: ['/uikit/menu']},
                            {label: 'Message', icon: 'pi pi-fw pi-comment', routerLink: ['/uikit/message']},
                            {label: 'Misc', icon: 'pi pi-fw pi-circle-off', routerLink: ['/uikit/misc']}
                        ]
                    }
                ]
            ]
        },
        {
            label: 'UTILITIES',
            items: [
                [
                    {
                        label: 'UTILITIES 1',
                        items: [
                            {label: 'Display', icon: 'pi pi-fw pi-desktop', routerLink: ['utilities/display']},
                            {label: 'Elevation', icon: 'pi pi-fw pi-external-link', routerLink: ['utilities/elevation']}
                        ]
                    },
                    {
                        label: 'UTILITIES 2',
                        items: [
                            {label: 'FlexBox', icon: 'pi pi-fw pi-directions', routerLink: ['utilities/flexbox']}
                        ]
                    }
                ],
                [
                    {
                        label: 'UTILITIES 3',
                        items: [
                            {label: 'Icons', icon: 'pi pi-fw pi-search', routerLink: ['utilities/icons']}
                        ]
                    },
                    {
                        label: 'UTILITIES 4',
                        items: [
                            {label: 'Text', icon: 'pi pi-fw pi-pencil', routerLink: ['utilities/text']},
                            {label: 'Widgets', icon: 'pi pi-fw pi-star-o', routerLink: ['utilities/widgets']}
                        ]
                    }
                ],
                [
                    {
                        label: 'UTILITIES 5',
                        items: [
                            {label: 'Grid System', icon: 'pi pi-fw pi-th-large', routerLink: ['utilities/grid']},
                            {label: 'Spacing', icon: 'pi pi-fw pi-arrow-right', routerLink: ['utilities/spacing']},
                            {
                                label: 'Typography',
                                icon: 'pi pi-fw pi-align-center',
                                routerLink: ['utilities/typography']
                            }
                        ]
                    }
                ],
            ]
        }
    ];
    @ViewChild('searchInput') searchInputViewChild: ElementRef;
    companies: any = [];

    constructor(public appMain: AppMainComponent,
                public app: AppComponent,
                public authService: AuthenticationService,
                public cacheService: CacheService,
                private commonService: CommonService,
                private userMgmtService: UserMgmtService,
                private messageService: MessageService,
                private loginDetailsService: LoginDetailsService
    ) {
        this.getDomainsByLoggedInUser();
        loginDetailsService.loggedInUser
            .subscribe((user) => {
                this.loggedInUser = user;
            });

    }

    onSearchAnimationEnd(event: AnimationEvent) {
        switch (event.toState) {
            case 'visible':
                this.searchInputViewChild.nativeElement.focus();
                break;
        }
    }

    applyFilterToSelectedUser(event) {
        this.switchUserRole = false;
        if (!this.selectedRoles.includes(event?.roles)) {
            this.selectedRoles.push(
                event?.roles
            );
            console.log('Roles', this.selectedRoles);
            this.cacheService.cacheResponse('selected-role', this.selectedRoles);
            // window.location.reload();
            return;
        }
        console.log('No new roles');


    }

    getDomainsByLoggedInUser() {
        this.companies = [];
        this.userMgmtService
            .getDomainsByUserLoggedIn()
            .subscribe(
                (x) => {
                    this.companies = x;
                }, error => {
                    this.messageService.add({
                        summary: 'Domains Error'
                    });
                }
            );
    }

    storeSelectedCompanies() {
        if (!this.selectedCompanies) {
            this.selectedCompanies = [];
        }
        this.cacheService.cacheResponse('selected-companies-array', this.selectedCompanies);
        const selectedCompaniesId = this.selectedCompanies?.map((x) => {
            return x.domainId;
        });
        console.log(selectedCompaniesId);
        this.cacheService.cacheResponse('selected-companies', selectedCompaniesId);
        const selectedCompanyName = this.selectedCompanies?.map((x) => {
            return x.domainName;
        });

        this.cacheService.cacheResponse('selected-companies-name', selectedCompanyName);
        window.location.reload();
    }

    // getLoggedInUser() {
    //     this.imUserService
    //         .getLoggedInUser()
    //         .subscribe(
    //             (x) => {
    //                 const userId = x.userId;
    //                 this.getDetailedLoggedInUser(userId);
    //             });
    // }
    //
    // getDetailedLoggedInUser(userId: any) {
    //     this.imUserService
    //         .getDetailedLoginUser(userId)
    //         .subscribe((x) => {
    //             this.cacheService.cacheResponse('detailedLoggedInUser', x);
    //             this.loggedInUser = x;
    //         });
    // }
}
